'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiMediaPlayReverse = function TiMediaPlayReverse(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm23.3 31.7c1.9 0 3.4-1.5 3.4-3.4v-16.6c0-1.9-1.5-3.4-3.4-3.4-0.8 0-1.6 0.4-2.3 1-4.3 4.2-11 10.7-11 10.7s6.7 6.5 11 10.7c0.7 0.6 1.5 1 2.3 1z' })
        )
    );
};

exports.default = TiMediaPlayReverse;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/media-play-reverse.js
// module id = 3139
// module chunks = 0